interface AppWindow extends Window {
  _application: {
    path: string,
    props: ViewProps,
  }
}

declare const window: AppWindow

const viewProps: ViewProps = window._application.props
const path = window._application.path
  .replace(/^\//, '') // trim initial slash
  .replace(/\/$/, '') // trim trailing slash
  .replace(/^$/, 'index') // "index" for "/"

/**
 * ページのマウントコンポーネントをページパスから動的に import する
 *
 * @param path 読み込むページコンポーネントのパス
 * @description マウントコンポーネントのディレクトリ構造と、ページのパスは一致させること（具体的には、サーバから script 要素で渡される window._application.path の内容とページコンポーネント階層を一致させる）
 * @description マウントコンポーネント名は必ず App.vue とする
 * @description
 *  rollup.js の制約により、import のパス部分が変数の場合、
 *  その変数に「/」が含まれる階層構造になっていると読み込めないため、
 *  パスを階層ごとに分解する必要がある。
 *  @see https://qiita.com/Hotari/items/fd03a481a979dffa16e3
 *  @see https://github.com/rollup/plugins/tree/master/packages/dynamic-import-vars#limitations
 *  @see https://github.com/vitejs/vite/issues/4945
 */
async function importMountComponent(path: string) {
  const layer = path.split('/').filter(p => p.length > 0)

  switch (layer.length) {
    case 0: throw 'No path: ' + path
    case 1: return (await import(`@/pages/${layer[0]}/App.vue`))
    case 2: return (await import(`@/pages/${layer[0]}/${layer[1]}/App.vue`))
    case 3: return (await import(`@/pages/${layer[0]}/${layer[1]}/${layer[2]}/App.vue`))
    case 4: return (await import(`@/pages/${layer[0]}/${layer[1]}/${layer[2]}/${layer[3]}/App.vue`))
    default: throw 'Too deep path: ' + path
  }
}
export { importMountComponent, path, viewProps }
